<!-- SQUARE ad -->
@if (advertisementType == AdvertisementEnum.SQUARE && advertisementObj?.length > 0) {
  <div class="adv-wrapper adv-wrapper--square"
    >
    <span class="adv-label">פרסום</span>
    <a class="adv-card" [href]="advertisementObj?.[0]?.linkAdv" target="_blank" rel="noopener sponsored">
      @if (!imageLoaded) {
        <div class="adv-spinner">
          <div class="spinner-ring"></div>
        </div>
      }
      <img [src]="advertisementObj?.[0]?.image" alt="פרסומת" loading="lazy"
        [class.img-visible]="imageLoaded"
        (load)="onImageLoad()" (error)="onImageLoad()">
        <div class="adv-shine"></div>
      </a>
    </div>
  }

  <!-- EXTEND (full-width) banner -->
  @if (advertisementType == AdvertisementEnum.EXTEND_BANNER && advertisementObj?.length > 0) {
    <div class="adv-wrapper adv-wrapper--extend"
      >
      <span class="adv-label">פרסום</span>
      <a class="adv-card adv-card--wide" [href]="advertisementObj?.[0]?.linkAdv" target="_blank" rel="noopener sponsored">
        @if (!imageLoaded) {
          <div class="adv-spinner">
            <div class="spinner-ring"></div>
          </div>
        }
        <img [src]="advertisementObj?.[0]?.image" alt="פרסומת" loading="lazy"
          [class.img-visible]="imageLoaded"
          (load)="onImageLoad()" (error)="onImageLoad()">
          <div class="adv-shine"></div>
        </a>
      </div>
    }

    <!-- BANNER_ADV (double banner via offer-product) -->
    @if (advertisementType == AdvertisementEnum.BANNER_ADV && advertisementObj != null) {
      <div class="adv-wrapper">
        <app-offer-product [advertisement]="advertisementObj"></app-offer-product>
      </div>
    }
